export enum EBitfOnlineStates {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}
